/*
 * filter-bar (Figma 119:44911): --surface-default, bottom 1px --border-strong.
 * Row 1: [padding 16px 32px (Figma 24px; denser, 2026-10-03): ghost "Filtrid" button + 16px caret] | 1px --border-strong rule |
 *        [active filters: padding-x 16px, bottom 1px --border-strong, medium Chips].
 * Row 2 (expanded): gap 24, padding 16px 32px, the filter fields.
 * Not in the design: density "compact" (row 1 padding 12px 32px, 56px high; default is 64px).
 * Narrow screens (not in Figma): the sides are the page gutter (--layout-page-padding-x); the
 * active filters wrap; on a phone (below 640) the fields stack, each the full width (a field's own
 * width is ignored there), 16px apart.
 */
import type { ReactNode } from 'react'
import { Button } from './Button'
import { cx } from './cx'
import { Chip } from './Chip'
import { caretDown16Filters } from './icons'

export interface ActiveFilter {
    key: string
    label: string
    onRemove: () => void
}

export function FilterBar({
    toggleLabel,
    expanded,
    onToggle,
    active,
    removeLabel,
    children,
    density = 'default',
}: {
    toggleLabel: string
    expanded: boolean
    onToggle: () => void
    active: ActiveFilter[]
    removeLabel: (label: string) => string
    children: ReactNode
    /** "compact": 16px instead of 24px above and below the toggle. */
    density?: 'default' | 'compact'
}) {
    return (
        <div className="flex w-full flex-col items-start border-b border-solid border-[var(--border-strong)] bg-[var(--surface-default)]">
            <div className="flex w-full items-center">
                <div className={cx('flex shrink-0 flex-col items-start px-[var(--layout-page-padding-x)]', density === 'compact' ? 'py-[12px]' : 'py-[16px]')}>
                    <Button variant="ghost" trailingIcon={caretDown16Filters} aria-expanded={expanded} onClick={onToggle}>
                        {toggleLabel}
                    </Button>
                </div>
                <div className="w-px self-stretch bg-[var(--border-strong)]" aria-hidden />
                <div className="flex min-w-px flex-1 flex-wrap items-center gap-[8px] self-stretch border-b border-solid border-[var(--border-strong)] px-[16px] max-sm:py-[8px]">
                    {active.map((filter) => (
                        <Chip key={filter.key} size="medium" label={filter.label} onRemove={filter.onRemove} removeLabel={removeLabel(filter.label)} />
                    ))}
                </div>
            </div>
            {expanded && (
                <div className="flex w-full flex-wrap items-start gap-[24px] px-[var(--layout-page-padding-x)] py-[16px] max-sm:flex-col max-sm:items-stretch max-sm:gap-[16px] max-sm:*:w-full!">
                    {children}
                </div>
            )}
        </div>
    )
}
